import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import { InfoModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";
import { useTranslation } from "react-i18next";

export function CancelReasonPopup({setBtnPopup, meetingDetails}) {
  const {t} = useTranslation()
  return (
    <div className={`${InfoModalStyle.ModalOverlay}`}>
      <div className={`${InfoModalStyle.Modal} ${PageStyle.CancelReason__inner} mw-90-xs`}>
        <div className={`${InfoModalStyle.Modal__Container}`}>
          <div className={`${InfoModalStyle.Modal__Container__Heading__Close}`}>
            <h3 className={`${InfoModalStyle.Modal__Container__ContentSection__Heading} mt0`}>{t('modal:cancelled_interview:heading')}</h3>
            <div
              className={`${InfoModalStyle.Modal__Container__CloseSection}`}
              onClick={()=> setBtnPopup(false)}>
              <Close/>
          </div>
        </div>
        <div className={`CancelInterview ${InfoModalStyle.Modal__Container__ContentSection} ${PageStyle.CancelReason__Content} DisplayInline`}>
            <div className={`${InfoModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.CancelReason__ContentBlock} mt30`}>
              <label className={`${InfoModalStyle.Modal__Container__ContentSection__Block__Heading}`}>{t('modal:cancelled_interview:reason')}</label>
            </div>
            <div className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.CancelReason__ContentBlock}`}>
              <p className={`${InfoModalStyle.Modal__Container__ContentSection__Point}`}>{meetingDetails.details?.reason}</p>
            </div> 
           </div>
        </div>
      </div>
    </div>
  )

}
